import { render } from "./portfolioHealth.vue?vue&type=template&id=5c96563e&scoped=true"
import script from "./portfolioHealth.vue?vue&type=script&lang=js"
export * from "./portfolioHealth.vue?vue&type=script&lang=js"

import "./portfolioHealth.vue?vue&type=style&index=0&id=5c96563e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c96563e"]])

export default __exports__